import { CSSObject } from '@chakra-ui/react';
import bgDesktop from '@/assets/chromabet/images/onboarding-aside.png';
import bgMobile from '@/assets/chromabet/images/onboarding-aside-mb.png';

export const WrapperAside: CSSObject = {
  bg: [`url(${bgMobile})`, null, `url(${bgDesktop}), #7DFD2A`],
  bgSize: ['cover', null, 'contain'],
  bgRepeat: ['no-repeat', null, 'no-repeat'],
  display: 'flex',
  flexDir: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  borderBottom: ['3px', null, 'unset'],
  borderBottomColor: ['beta.500', null, 'unset'],
  h: ['50vw', '55vw', 'full'],
  borderLeftRadius: [null, null, '10px'],
  borderRightRadius: ['unset'],
  flex: 1,
  a: {
    h: 52,
    img: {
      maxW: ['58vw', '500px', '200px'],
    },
  },
  fontFamily: 'accent',
};
